import { NoteTypeItemResponse, NoteTypeResponse } from '@/types/service-response'

export class NoteType {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: NoteTypeResponse): Array<NoteType> {
    let result: Array<NoteType> = []
    if (responseData) {
      result = responseData.map((item: NoteTypeItemResponse ) => {
        return new NoteType(
          item.ID,
          item.Bezeichnung
        )
      })
    }
    return result
  }
}
